import React from "react"
import { Link } from 'gatsby'

const demo = { backgroundColor: "#333399", color: "white", padding: "5px", fontSize: "1.2em", textDecoration: "none" }

const SecondPage = () => (
  <div>
    <h1>gatsby-plugin-mdx</h1>
    <Link to="contact" style={demo}>Demo</Link><br /><br />
    <p>How to install gatsby-plugin-mdx</p>
    <li>npm install gatsby-plugin-mdx @mdx-js/mdx @mdx-js/react</li>
    <li>add this configuration in gatsby-config.js</li>
    <pre>{`
    plugins:[
      {
        resolve: 'gatsby-plugin-mdx',
        options: {
          defaultLayouts: {
            default: require.resolve('./src/components/layout.js')
          }
        },
      }
      ]
    `}</pre>
    <li>Create an .mdx file in the pages folder.</li>
    <li>Import and write React!</li>
  </div>
)

export default SecondPage